import React, { Component, Fragment } from 'react';
import Navbar from '../components/Navbar';
import AmazonLink from '../components/AmazonLink';
import { Link } from '../components/Iframe';
import MailingList from '../components/MailingList';
import Timeline from '../components/Timeline';
export default class Index extends Component {
  render() {
    var amazon_links = [
      { product: '1612680194', link_id: '7c22ab5cbbb40e42d70e4a4cb863651a', name: 'Rich Dad poor dad' },
      { product: '1524763438', link_id: 'ba4430b17893e4e9925cad91bc930c8a', name: '100 questions' },
      // { product: 'B000YHH1S8', link_id: 'aebec3ea95b28c49827102aa722071bd', name: 'Millionaire realestate investor' },
      // { product: 'B00PL16ASY', link_id: '954b40a57dff38c69ea962e83f4d6a0c', name: 'No Money Down' },
      // { product: 'B0195LQU2G', link_id: 'dc31b29d59b5b70ae49ea33a54e19872', name: 'Rental Property Investing' },
      { product: '111919170X', link_id: '853175315f0331fc9f3479751a51b3f2', name: 'Home buying kit for dummies' },
      // {
      //   product: '1118948211',
      //   link_id: '5c8e04ff4f39340d4152e4e8762bf619',
      //   name: 'Real estate investing for dummies',
      // },
      // { product: '099758470X', link_id: 'dba74c448e7d9e6768640eef62c3cb9c', name: 'Real estate investing for dummies' },
      { product: '0988973715', link_id: '380fafd27f5f09a7cfef028744c84ab6', name: 'Book on estimating rehab cost' },
    ];

    return (
      <Fragment>
        <title>PropertyHints</title>

        <Navbar homepage={true} />

        <Fragment>
          <div id="hero" style={{ top: '-100px', height: '500px' }}>
            <div className="container">
              <h1 className="hero-text animated fadeInDown" style={{ marginTop: '-20px', textAlign: 'center' }}>
                Helping you with property in NZ
              </h1>
              <div class="row feature ">
                <div
                  class="col-md-offset-2 col-md-8"
                  style={{ padding: '20px', backgroundColor: 'rgb(245, 245, 245,0.8)' }}
                >
                  <h4 align="center">
                    Not sure where to start? <a href="/walkthrough">View our property buying walkthrough!</a>
                  </h4>
                  <hr />
                  <Timeline intro={true} />
                </div>
              </div>
            </div>
          </div>
          <div class="container container-wide ">
            <div class="row feature">
              <div class="col-md-12 ">
                <div id="features" style={{ marginTop: '-130px' }}>
                  <div>
                    <div className="row feature">
                      <div className="col-md-6 info">
                        <h4>Popular Articles</h4>
                        <hr />
                        <div class="paper">
                          <a href="/our-story">Our Story</a>
                          <p style={{ padding: '0px', margin: '0px' }}>
                            <small>
                              We began our house hunt back in 2016 and it took 6 offers over 2 years before we managed
                              to win our house... <a href="/our-story">read more</a>
                            </small>
                          </p>
                        </div>
                        <div class="paper">
                          <a href="/steps-to-buy">Steps to buy a house</a>
                        </div>
                        <div class="paper">
                          <a href="/ways-to-purchase">Different methods of buying and selling property</a>
                        </div>
                        <div class="paper">
                          <a href="/how-much-can-you-get">How much can you get?</a>
                        </div>
                        <div class="paper">
                          <a href="/putting-in-an-offer">Putting in an offer</a>
                        </div>
                        <div class="paper">
                          <a href="/dealing-with-agents">Dealing with Real Estate Agents</a>
                        </div>
                      </div>
                      <div className="col-md-6 info">
                        <h4>Useful Articles</h4>
                        <hr />
                        <div class="paper">
                          <Link id="top-10-mistakes-kiwi-property-investors-make" />
                        </div>
                        <div class="paper">
                          <Link id="what-to-check-for-when-looking-at-a-house" />
                        </div>
                        <div class="paper">
                          <Link id="buying-a-first-home" />
                        </div>
                        <div class="paper">
                          <Link id="making-an-offer" />
                        </div>
                        <div class="paper">
                          <Link id="buying-or-building" />
                        </div>
                      </div>
                      <div className="col-md-12 info">
                        <h4>Useful Reads</h4>
                      </div>
                      {amazon_links.map(link => (
                        <div className="col-md-2 col-sm-3 col-xs-4 info">
                          <AmazonLink product={link.product} link_id={link.link_id} />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div id="testimonials" style={{ marginTop: '20px' }}>
                  <div>
                    <div className="row header">
                      <div className="col-md-12">
                        <h3>Latest Info:</h3>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="testimonial pull-right">
                          <div className="quote" style={{ borderColor: '#21bd1e' }}>
                            Myself and my partner have been hunting for a house in Wellington NZ for a while now. We
                            have learned a lot, and have decided it's about time we shared it to help out those people
                            in the same boat.
                            <br />
                            <br />
                            Hopefully you find something here that is useful to you!
                            <div className="arrow-down">
                              <div className="arrow" style={{ borderColor: '#21bd1e transparent transparent' }} />
                              <div className="arrow-border" />
                            </div>
                          </div>
                          <br />
                          <div className="quote" style={{ borderColor: '#21bd1e' }}>
                            We got a house!
                            <br />
                            <br />
                            All that research paid off, keep watch for the articles and hints to come
                          </div>
                          <br />
                        </div>
                      </div>
                      <div className="col-md-12 info">
                        <MailingList />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Index.jsx